import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { ModalBrand } from "@components/modules/brands/ModalBrand";
import { Trans, t } from "@lingui/macro";
import { useCreateClientMutation } from "@src/__generated__/graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { onError } from "@src/utils/apollo";
import { can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { ModalClient } from "../../clients/detail/modals/client/ModalClient";
import type { TBrandFillFromClient } from "../ModalBrand/ModalBrand";

export const AddBtn = observer(function AddBtn() {
  const addModal = useDisclosure();
  const addClientModal = useDisclosure();
  const [clientFill, setClientFill] = useState<string>();
  const [brandFillData, setBrandFillData] = useState<
    (TBrandFillFromClient & { clientId?: string }) | undefined
  >();

  const [createClient, createClientReq] = useCreateClientMutation({
    onCompleted({ createClient }) {
      addClientModal.onClose();
      const clientNameSplit = createClient.name.split(" ");

      setBrandFillData({
        name: createClient.name,
        clientId: createClient.id,
        code:
          clientNameSplit.length > 1
            ? clientNameSplit.reduce((prev, word) => {
                if (!word[0]) return prev;

                return prev + word[0].toUpperCase();
              }, "")
            : clientNameSplit?.[0].substring(0, 2).toUpperCase(),
      });

      addModal.onOpen();
    },
    ...onError(),
  });

  const handleBrandModalClose = () => {
    addModal.onClose();
    setBrandFillData(undefined);
  };

  return (
    <Box>
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<Icon name="chevron-down" />}
          variant="solid"
        >
          <Trans>Add new</Trans>
        </MenuButton>
        <MenuList>
          {can("brand_create") && (
            <MenuItem onClick={addModal.onOpen}>
              <Trans>Add Brand</Trans>
            </MenuItem>
          )}
          {can("client_create") && (
            <MenuItem {...addClientModal.getButtonProps()}>
              <Trans>Add Client</Trans>
            </MenuItem>
          )}
        </MenuList>
      </Menu>

      <ModalBrand
        {...addModal}
        clientId={brandFillData?.clientId}
        brandFill={brandFillData}
        onClose={handleBrandModalClose}
        onSubmit={() => {}}
        onCreateClientClick={addClientModal.onOpen}
        onNameChange={setClientFill}
      />

      <ModalClient
        {...addClientModal.getDisclosureProps()}
        {...addClientModal}
        title={t`Add client`}
        defaultName={clientFill}
        isLoading={createClientReq.loading}
        onSubmit={async (val) => {
          await createClient({ variables: { input: { ...val } } });
        }}
      />
    </Box>
  );
});
